import userflow from 'userflow.js';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Badge from 'components/field/Badge';
import SwitchInput from 'components/field/SwitchInput';
import Alert from 'components/global/Alert';
import Authorization from 'components/global/Authorization';
import Card from 'components/global/Card';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Typography from 'components/global/Typography';

import { getPackagesAndModules } from 'pages/OTOModules/OTOPackageListSlice';

import PATHS from 'utils/paths';

import Modules from './Modules';
import * as S from './OTOModules.styled';
import Packages from './Packages';

const PlanTypes = {
	monthly: 'monthly',
	yearly: 'yearly'
};

const OTOModules = () => {
	const [planType, setPlanType] = useState(PlanTypes.monthly);
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state.otoPackageList);
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(getPackagesAndModules());
	}, []);

	if (loading) {
		return <Loading />;
	}
	return (
		<div>
			<PageHeader
				title="otoModules"
				tooltip="otoModules.tooltip"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/logs-icon.json.gz"
			/>
			<Card>
				<S.Header>
					<div>
						<Typography variant="p2" fontWeight="700" className="mb-3">
							otoPlans
						</Typography>
						<Typography variant="p3" color="var(--content-2)">
							otoPlansDescription
						</Typography>
					</div>
					<S.PriceSwitch>
						<Typography variant="p3" fontWeight="500">
							{PlanTypes.monthly}
						</Typography>

						<SwitchInput
							value={planType === PlanTypes.yearly}
							setValue={() => {
								setPlanType(planType === PlanTypes.yearly ? PlanTypes.monthly : PlanTypes.yearly);
							}}
						/>
						<Typography variant="p3" fontWeight="500">
							{PlanTypes.yearly}
						</Typography>
						<Badge variant="pill" size="small" color="green" text="otoModule.discount" />
					</S.PriceSwitch>
				</S.Header>
				<S.Container>
					<Packages planType={planType} PlanTypes={PlanTypes} />
					<Authorization path={PATHS.SAVINGS_CALCULATOR}>
						<Alert
							header="savingsCalculatorAlertHeader"
							content="savingsCalculatorAlertContent"
							ctaButtonLabel="goToSavingsCalculator"
							showIcon
							iconUrl="https://storage.googleapis.com/tryoto-public/public/assets/icons/Savings-Calculator/savings-calculator-icon.svg"
							onCtaButtonClick={() => navigate(PATHS.SAVINGS_CALCULATOR)}
							style={{
								backgroundColor: 'var(--table-active-color)'
							}}
						/>
					</Authorization>
					<Modules />
					<Alert
						iconUrl="https://storage.googleapis.com/tryoto-public/public/assets/icons/OTO-Modules/Request%20Feature.svg"
						variant="info"
						header="requestModuleInfo"
						content="requestModuleDescription"
						className="mb-3"
						onCtaButtonClick={() => userflow.start('2b5abe77-a007-414b-a7de-b77a3fe9fe8d')}
						ctaButtonLabel="requestModule"
						style={{
							backgroundColor: 'var(--table-active-color)'
						}}
						showIcon
					/>
				</S.Container>
			</Card>
		</div>
	);
};

export default OTOModules;
